
import Dashboard from "../../common/components/layout/Dashboard"
import Toast from "../../common/components/ui/toast"
import { ToastProvider } from "../../common/components/ui/toast/toast.provider"
import TableCompanyManagement from "./components/table-companies/TableCompanyManagement"


function CompanyManagementPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableCompanyManagement />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default CompanyManagementPage